import { Image, View } from "react-native";
import { memo } from "react";
import { IVoice } from "../../../../types/voice";
import StyledText from "../../../common/ui/styled-text";
import { User } from "lucide-react-native";

interface VoiceSelectItemProps {
  voice: IVoice | null;
}

const defaultAvatarUrl = require("../../../../assets/default-avatar.png");

const VoiceSelectItem = memo(function VoiceSelectItem({
  voice,
}: VoiceSelectItemProps) {
  return (
    <View className="flex-row items-center gap-3 min-h-[48px] px-2 py-2">
      <View className="h-8 w-8 rounded-full overflow-hidden shrink-0">
        {!voice ? (
          <User size={24} color="#111827" />
        ) : (
          <Image
            source={
              voice.avatar_url ? { uri: voice.avatar_url } : defaultAvatarUrl
            }
            style={{ width: "100%", height: "100%" }}
            resizeMode="cover"
          />
        )}
      </View>
      <View className="flex-1">
        <StyledText className="font-light" numberOfLines={1}>
          {voice?.voice_name || "Custom Voice"}
        </StyledText>
        {voice?.accent && voice?.age && (
          <StyledText
            className="font-light text-xs text-muted-foreground"
            numberOfLines={1}
          >
            {voice.accent} · {voice.age}
          </StyledText>
        )}
      </View>
    </View>
  );
});

export default VoiceSelectItem;
